export const SyncraIcon = ({
  width,
  height,
  isDark,
}: {
  width: number
  height: number
  isDark: boolean
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 146 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="whitespace-nowrap"
  >
    <g clipPath="url(#clip0_2465_12526)">
      <path
        d="M53.2231 32.1325C49.779 32.1325 47.38 30.8783 45.3066 29.5552V25.7234C47.3971 27.2869 50.2245 28.9194 53.2746 28.9194C55.9991 28.9194 58.0897 27.2869 58.0897 24.2972C58.0897 22.1837 56.2218 20.8778 52.7262 19.5376C48.7679 18.0599 45.5465 16.3587 45.5465 11.9083C45.5465 7.56111 49.0078 4.57129 53.6345 4.57129C56.1019 4.57129 58.2267 5.2586 60.3002 6.47858V10.087C58.4666 8.67799 55.982 7.75011 53.6859 7.75011C50.9099 7.75011 49.025 9.62304 49.025 12.0114C49.025 14.7435 51.5268 15.7229 54.3027 16.7195C58.7751 18.2832 61.6538 20.517 61.6538 24.2972C61.6538 29.3317 58.0211 32.1325 53.2231 32.1325Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M75.5156 14.916H78.9085L72.5512 31.8754L72.0371 33.2844C70.2722 38.4049 68.0103 39.7108 65.8856 39.7108C64.4119 39.7108 63.6751 39.4874 62.904 39.2813L62.6641 36.3945C63.3838 36.6694 64.0178 36.8757 65.1829 36.8757C66.5196 36.8757 67.7361 35.7072 68.7642 32.8549L69.2954 31.2741L62.9897 14.916H66.6566L71.0604 27.3906H71.1118L75.5156 14.916Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M90.8357 14.3486C94.7598 14.3486 96.9702 16.7027 96.9702 22.0466V31.4971H93.6288V21.995C93.6288 18.6787 92.2923 17.2354 89.8247 17.2354C88.1284 17.2354 86.3805 18.335 85.2496 19.9158V31.4971H81.9082V14.9157H84.7698L85.2153 17.0119C86.7061 15.4483 88.848 14.3486 90.8357 14.3486Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M109.548 32.0642C104.459 32.0642 100.586 28.3011 100.586 23.215C100.586 18.1289 104.459 14.3486 109.565 14.3486C111.655 14.3486 113.129 14.9329 114.483 15.8779L114.671 18.9537C113.472 17.8539 111.673 17.1494 109.77 17.1494C106.395 17.1494 103.79 19.7956 103.79 23.215C103.79 26.6515 106.395 29.2805 109.788 29.2805C111.655 29.2805 113.403 28.5761 114.62 27.4591L114.551 30.5349C113.232 31.4627 111.69 32.0642 109.548 32.0642Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M128.791 14.7438L128.962 17.8367C128.019 17.4759 127.146 17.3385 126.323 17.3385C124.747 17.3385 123.222 18.3006 122.159 20.0533V31.4971H118.818V14.9157H121.679L122.073 16.9948C123.444 15.2078 125.038 14.3486 126.649 14.3486C127.386 14.3486 128.191 14.4689 128.791 14.7438Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M138.025 14.3652C143.251 14.3652 145.291 17.2004 145.291 21.6851L145.274 31.4965H142.412L142.001 29.5721C140.544 31.0669 138.42 32.0636 136.175 32.0636C132.765 32.0636 130.691 30.0704 130.691 26.8744C130.691 23.6784 133.313 21.3759 137.1 21.3759C138.591 21.3759 140.339 21.5649 141.932 21.8055V21.6851C141.932 19.0733 141.127 17.441 137.511 17.441C135.027 17.441 133.09 18.2485 131.342 19.1937L131.634 16.0148C133.415 15.0525 135.455 14.3652 138.025 14.3652ZM137.22 29.1597C139.019 29.1597 140.732 28.2319 141.932 26.7198V24.2111C140.63 23.9705 139.224 23.7986 137.751 23.7986C135.386 23.7986 134.033 24.5547 134.016 26.5651C133.999 28.0256 135.027 29.1597 137.22 29.1597Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <g clipPath="url(#clip1_2465_12526)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0104367 16.3211V32.3617C4.97221 34.5555 11.6925 36 17.9031 36C25.417 36 30.5189 33.0802 30.5189 29.357C30.5189 25.0983 23.7472 23.5714 16.2334 22.0177C9.08053 20.5775 3.43372 18.7726 0.0104367 16.3211ZM36.9749 6.5334V23.6036C33.5349 20.753 27.4355 19.116 20.5004 17.625C11.0387 15.5357 5.98318 13.5 5.98318 10.2054C5.98318 5.54463 11.6417 3 19.0164 3C25.6273 3 31.8516 4.63166 36.9749 6.5334Z"
          fill={isDark ? '#6C6CE1' : '#5959ff'}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2465_12526">
        <rect width="145.882" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_2465_12526">
        <rect width="36" height="36" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
)
